import React from 'react';
export function CostOfNotHaving() {
  const rows = [{
    no: 'Lunes buscando dietas que no funcionan',
    yes: 'Semanas de tu vida que no recuperás nunca'
  }, {
    no: 'Ingredientes de dietas que terminan en la basura',
    yes: 'Plata perdida en cada intento fallido'
  }, {
    no: 'Sin alimentación diseñada para tu metabolismo',
    yes: 'Seguís con la panza y el cansancio sin solución'
  }, {
    no: 'Sin entender tus hormonas y tus análisis',
    yes: 'Vas al médico sin saber qué preguntar'
  }, {
    no: 'Sin método específico para la menopausia',
    yes: 'Seguís probando lo que funcionaba a los 30'
  }, {
    no: 'Sin plan paso a paso probado',
    yes: 'Te rendís antes de empezar, una y otra vez'
  }];
  return <div className="bg-[#0c0c0c] py-16 px-6" data-id="element-108">
      <div className="max-w-[960px] mx-auto" data-id="element-109">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-110">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-7 uppercase" data-id="element-111">
          Sin MegaPack vs. Con MegaPack
        </h2>

        <div className="overflow-x-auto" data-id="element-112">
          <table className="w-full border-collapse text-[14px]" data-id="element-113">
            <thead data-id="element-114">
              <tr data-id="element-115">
                <th className="bg-white/5 py-3.5 px-4.5 font-display tracking-[1px] uppercase text-[12px] text-brand-red text-left" data-id="element-116">
                  ❌ Sin MegaPack
                </th>
                <th className="bg-white/5 py-3.5 px-4.5 font-display tracking-[1px] uppercase text-[12px] text-brand-gold text-left" data-id="element-117">
                  💸 Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-118">
              {rows.map((row, i) => <tr key={i} data-id="element-119">
                  <td className="py-3.5 px-4.5 border-b border-brand-border align-top text-white/50" data-id="element-120">
                    {row.no}
                  </td>
                  <td className="py-3.5 px-4.5 border-b border-brand-border align-top text-white/85 font-semibold" data-id="element-121">
                    {row.yes}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="text-center font-display text-[18px] text-white mt-7 leading-[1.6] uppercase" data-id="element-122">
          El próximo lunes podés estar viendo cambios en tu cuerpo
          <br data-id="element-123" />
          — o buscando otra dieta que tampoco va a funcionar.
          <br data-id="element-124" />
          <span className="text-brand-green" data-id="element-125">
            La diferencia es un solo clic.
          </span>
        </p>
      </div>
    </div>;
}